<script lang="ts">
	import ArticleCard from 'components/LearnPage/ArticleCard/ArticleCard.svelte';

	export let dark = false;
	export let articles;
</script>

<section class="articles-wrapper" class:dark>
	<ul class="articles-list">
		{#each articles as article}
			<li class="list-item">
				<ArticleCard {dark} {article} />
			</li>
		{/each}
	</ul>
</section>

<style lang="scss">
	@import 'articlesSection';
</style>
